export default [
  "#9a0000",
  "#bf4c53",
  "#d6858b",
  "#c86627",
  "#d88c68",
  "#e3af99",
  "#d99b34",
  "#e4b273",
  "#ecc9a1",
  "#ead442",
  "#f0dd67",
  "#f9f1cd",
  "#cfda3e",
  "#d8e08a",
  "#dee3ad",
  "#7ecf35",
  "#a8d980",
  "#cbe1ba",
  "#14d8b4",
  "#37dfc6",
  "#c2f6e9",
  "#14dbd6",
  "#38e1de",
  "#c3f7f5",
  "#13a1c7",
  "#6cc4dc",
  "#c0e4f0",
  "#164eab",
  "#7491cb",
  "#30A245"
]